// store/Reports/SalesByCategoryReport/salesByCategoryReportConverter.ts

import type { SalesByCategoryReportDto } from './SalesByCategoryReportDto';
import type { SalesByCategoryReport } from 'model/SalesByCategoryReport';

export const convertToSalesByCategoryReport = (dto: SalesByCategoryReportDto): SalesByCategoryReport => {
    return {
        range: {
            start: dto.range.start,
            end: dto.range.end
        },
        totals: {
            quantity: dto.totals.quantity ?? 0,
            grossSales: dto.totals.gross_sales ?? 0,
            discounts: dto.totals.discounts ?? 0,
            refunds: dto.totals.refunds ?? 0,
            netSales: dto.totals.net_sales ?? 0
        },
        categories: (dto.categories ?? []).map(c => ({
            key: c.key,
            label: c.label,
            quantity: c.quantity ?? 0,
            grossSales: c.gross_sales ?? 0,
            discounts: c.discounts ?? 0,
            refunds: c.refunds ?? 0,
            netSales: c.net_sales ?? 0,
            netSalesPct: c.net_sales_pct ?? 0
        }))
    };
};
